var jade = require("/var/lib/jenkins-code/academia-app/node_modules/.pnpm/jade@1.11.0/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div role=\"tooltip\" class=\"popover js-NavSearch-bootstrapPopover NavSearch-bootstrapPopover\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>");;return buf.join("");
}